import { TypedDefinition } from '@rehaje/core'

import type { TypedSchema } from '@rehaje/core'

const MustacheRelationTo = [
  'Schema.JSExpression',
  'Schema.Expression',
  'Schema.Mustache'
]

export class MustacheDefinition extends TypedDefinition {
  override properties: TypedSchema[] = [
    {
      name: 'type',
      type: 'Schema.String'
    },
    {
      name: 'id',
      type: 'Schema.String'
    },
    {
      name: 'code',
      type: 'Schema.String'
    },
    {
      additionalParameters: {
        name: 'args',
        type: 'Schema.Any'
      },
      name: 'runner',
      return: {
        name: 'result',
        type: 'Schema.Any'
      },
      type: 'Schema.Function'
    }
  ]

  override relationTo = MustacheRelationTo
}

export class ExpressionDefinition extends MustacheDefinition {
  override relationTo = MustacheRelationTo
}

export class JSExpressionDefinition extends MustacheDefinition {
  override relationTo = MustacheRelationTo
}
